// JavaScript Document
const strLink1="https://interior-arne.com/products/"
function setGoods(url,haba,depth,height,thick,color){
this.url=url;
this.haba=haba;
this.depth=depth;
this.height=height;
this.thick=thick;
this.color=color;
}
function searchURL(){
var habaValue=document.getElementById("haba").value;
var depthValue=document.getElementById("depth").value;
var heightValue=document.getElementById("height").value;
var idColor = document.getElementsByName( "colortype" ) ;
for ( colorValue="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
  colorValue = idColor[i].id ;
  break ;
 }
}
if(habaValue=="haba-select" && depthValue=="depth-selected" && heightValue=="height-selected"){
alert("「幅・奥行・高さ」を選んでください");
return false;
}
if(habaValue=="haba-select" && depthValue=="depth-selected"){
alert("「幅・奥行」を選んでください");
return false;
}
if(habaValue=="haba-select" && heightValue=="height-selected"){
alert("「幅・高さ」を選んでください");
return false;
}
if(depthValue=="depth-selected" && heightValue=="height-selected"){
alert("「奥行・高さ」を選んでください");
return false;
}
if(habaValue=="haba-select"){
alert("「幅」を選んでください");
return false;
}
if(depthValue=="depth-selected"){
alert("「奥行」を選んでください");
return false;
}
if(heightValue=="height-selected"){
alert("「高さ」を選んでください");
return false;
}
if(colorValue==""){
alert("「カラー」を選んでください");
return false;
}
var url=document.getElementById("link_url");
for(var i in goods){
if(goods[i].haba==habaValue && goods[i].depth==depthValue && goods[i].height==heightValue && goods[i].color==colorValue){
return goods[i].url;
}
}
alert("ご希望サイズ幅"+habaValue+"cm×奥行"+depthValue+"cm×高さ"+heightValue+"cmは購入ページのご用意がございません。\nお手数をおかけしますがお見積りを出しますので当店までお問合せくださいませ。");
return false;
}
function jump(){
var idColor = document.getElementsByName( "colortype" ) ;
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
  strColor = idColor[i].id ;
  var valueColor = idColor[i].value ;
  break ;
 }
}
var url=searchURL();
if(!url){
return false;
}
window.open(strLink1+url)
return false;
}
goods = new Object();
goods[0] =new setGoods("0000ae014287","60","30","42","6","nail");
goods[1] =new setGoods("0000ae014288","70","30","42","6","nail");
goods[2] =new setGoods("0000ae014289","80","30","42","6","nail");
goods[3] =new setGoods("0000ae014290","90","30","42","6","nail");
goods[4] =new setGoods("0000ae014291","100","30","42","6","nail");
goods[5] =new setGoods("0000ae014292","110","30","42","6","nail");
goods[6] =new setGoods("0000ae014293","120","30","42","6","nail");
goods[7] =new setGoods("0000ae014294","130","30","42","6","nail");
goods[8] =new setGoods("0000ae014295","140","30","42","6","nail");
goods[9] =new setGoods("0000ae014296","150","30","42","6","nail");
goods[10] =new setGoods("0000ae014297","60","40","42","6","nail");
goods[11] =new setGoods("0000ae014298","70","40","42","6","nail");
goods[12] =new setGoods("0000ae014299","80","40","42","6","nail");
goods[13] =new setGoods("0000ae014300","90","40","42","6","nail");
goods[14] =new setGoods("0000ae014301","100","40","42","6","nail");
goods[15] =new setGoods("0000ae014302","110","40","42","6","nail");
goods[16] =new setGoods("0000ae014303","120","40","42","6","nail");
goods[17] =new setGoods("0000ae014304","130","40","42","6","nail");
goods[18] =new setGoods("0000ae014305","140","40","42","6","nail");
goods[19] =new setGoods("0000ae014306","150","40","42","6","nail");
goods[20] =new setGoods("0000ae014307","70","50","42","6","nail");
goods[21] =new setGoods("0000ae014308","80","50","42","6","nail");
goods[22] =new setGoods("0000ae014309","90","50","42","6","nail");
goods[23] =new setGoods("0000ae014310","100","50","42","6","nail");
goods[24] =new setGoods("0000ae014311","110","50","42","6","nail");
goods[25] =new setGoods("0000ae014312","120","50","42","6","nail");
goods[26] =new setGoods("0000ae014313","130","50","42","6","nail");
goods[27] =new setGoods("0000ae014314","140","50","42","6","nail");
goods[28] =new setGoods("0000ae014315","150","50","42","6","nail");
goods[29] =new setGoods("0000ae014316","90","60","42","6","nail");
goods[30] =new setGoods("0000ae014317","100","60","42","6","nail");
goods[31] =new setGoods("0000ae014318","110","60","42","6","nail");
goods[32] =new setGoods("0000ae014319","120","60","42","6","nail");
goods[33] =new setGoods("0000ae014320","130","60","42","6","nail");
goods[34] =new setGoods("0000ae014321","140","60","42","6","nail");
goods[35] =new setGoods("0000ae014322","150","60","42","6","nail");
goods[36] =new setGoods("0000ae014323","110","70","42","6","nail");
goods[37] =new setGoods("0000ae014324","120","70","42","6","nail");
goods[38] =new setGoods("0000ae014325","130","70","42","6","nail");
goods[39] =new setGoods("0000ae014326","140","70","42","6","nail");
goods[40] =new setGoods("0000ae014327","150","70","42","6","nail");
goods[41] =new setGoods("0000ae014328","110","80","42","6","nail");
goods[42] =new setGoods("0000ae014329","120","80","42","6","nail");
goods[43] =new setGoods("0000ae014330","130","80","42","6","nail");
goods[44] =new setGoods("0000ae014331","140","80","42","6","nail");
goods[45] =new setGoods("0000ae014332","150","80","42","6","nail");
goods[46] =new setGoods("0000ae014333","40","40","42","6","nail");
goods[47] =new setGoods("0000ae014334","50","50","42","6","nail");
goods[48] =new setGoods("0000ae014335","60","60","42","6","nail");
goods[49] =new setGoods("0000ae014336","70","70","42","6","nail");
goods[50] =new setGoods("0000ae014337","80","80","42","6","nail");
goods[51] =new setGoods("0000ae014338","90","90","42","6","nail");
goods[52] =new setGoods("0000ae014339","60","30","42","6","black");
goods[53] =new setGoods("0000ae014340","70","30","42","6","black");
goods[54] =new setGoods("0000ae014341","80","30","42","6","black");
goods[55] =new setGoods("0000ae014342","90","30","42","6","black");
goods[56] =new setGoods("0000ae014343","100","30","42","6","black");
goods[57] =new setGoods("0000ae014344","110","30","42","6","black");
goods[58] =new setGoods("0000ae014345","120","30","42","6","black");
goods[59] =new setGoods("0000ae014346","130","30","42","6","black");
goods[60] =new setGoods("0000ae014347","140","30","42","6","black");
goods[61] =new setGoods("0000ae014348","150","30","42","6","black");
goods[62] =new setGoods("0000ae014349","60","40","42","6","black");
goods[63] =new setGoods("0000ae014350","70","40","42","6","black");
goods[64] =new setGoods("0000ae014351","80","40","42","6","black");
goods[65] =new setGoods("0000ae014352","90","40","42","6","black");
goods[66] =new setGoods("0000ae014353","100","40","42","6","black");
goods[67] =new setGoods("0000ae014354","110","40","42","6","black");
goods[68] =new setGoods("0000ae014355","120","40","42","6","black");
goods[69] =new setGoods("0000ae014356","130","40","42","6","black");
goods[70] =new setGoods("0000ae014357","140","40","42","6","black");
goods[71] =new setGoods("0000ae014358","150","40","42","6","black");
goods[72] =new setGoods("0000ae014359","70","50","42","6","black");
goods[73] =new setGoods("0000ae014360","80","50","42","6","black");
goods[74] =new setGoods("0000ae014361","90","50","42","6","black");
goods[75] =new setGoods("0000ae014362","100","50","42","6","black");
goods[76] =new setGoods("0000ae014363","110","50","42","6","black");
goods[77] =new setGoods("0000ae014364","120","50","42","6","black");
goods[78] =new setGoods("0000ae014365","130","50","42","6","black");
goods[79] =new setGoods("0000ae014366","140","50","42","6","black");
goods[80] =new setGoods("0000ae014367","150","50","42","6","black");
goods[81] =new setGoods("0000ae014368","90","60","42","6","black");
goods[82] =new setGoods("0000ae014369","100","60","42","6","black");
goods[83] =new setGoods("0000ae014370","110","60","42","6","black");
goods[84] =new setGoods("0000ae014371","120","60","42","6","black");
goods[85] =new setGoods("0000ae014372","130","60","42","6","black");
goods[86] =new setGoods("0000ae014373","140","60","42","6","black");
goods[87] =new setGoods("0000ae014374","150","60","42","6","black");
goods[88] =new setGoods("0000ae014375","110","70","42","6","black");
goods[89] =new setGoods("0000ae014376","120","70","42","6","black");
goods[90] =new setGoods("0000ae014377","130","70","42","6","black");
goods[91] =new setGoods("0000ae014378","140","70","42","6","black");
goods[92] =new setGoods("0000ae014379","150","70","42","6","black");
goods[93] =new setGoods("0000ae014380","110","80","42","6","black");
goods[94] =new setGoods("0000ae014381","120","80","42","6","black");
goods[95] =new setGoods("0000ae014382","130","80","42","6","black");
goods[96] =new setGoods("0000ae014383","140","80","42","6","black");
goods[97] =new setGoods("0000ae014384","150","80","42","6","black");
goods[98] =new setGoods("0000ae014385","40","40","42","6","black");
goods[99] =new setGoods("0000ae014386","50","50","42","6","black");
goods[100] =new setGoods("0000ae014387","60","60","42","6","black");
goods[101] =new setGoods("0000ae014388","70","70","42","6","black");
goods[102] =new setGoods("0000ae014389","80","80","42","6","black");
goods[103] =new setGoods("0000ae014390","90","90","42","6","black");
goods[104] =new setGoods("0000ae014391","60","30","42","6","bp");
goods[105] =new setGoods("0000ae014392","70","30","42","6","bp");
goods[106] =new setGoods("0000ae014393","80","30","42","6","bp");
goods[107] =new setGoods("0000ae014394","90","30","42","6","bp");
goods[108] =new setGoods("0000ae014395","100","30","42","6","bp");
goods[109] =new setGoods("0000ae014396","110","30","42","6","bp");
goods[110] =new setGoods("0000ae014397","120","30","42","6","bp");
goods[111] =new setGoods("0000ae014398","130","30","42","6","bp");
goods[112] =new setGoods("0000ae014399","140","30","42","6","bp");
goods[113] =new setGoods("0000ae014400","150","30","42","6","bp");
goods[114] =new setGoods("0000ae014401","60","40","42","6","bp");
goods[115] =new setGoods("0000ae014402","70","40","42","6","bp");
goods[116] =new setGoods("0000ae014403","80","40","42","6","bp");
goods[117] =new setGoods("0000ae014404","90","40","42","6","bp");
goods[118] =new setGoods("0000ae014405","100","40","42","6","bp");
goods[119] =new setGoods("0000ae014406","110","40","42","6","bp");
goods[120] =new setGoods("0000ae014407","120","40","42","6","bp");
goods[121] =new setGoods("0000ae014408","130","40","42","6","bp");
goods[122] =new setGoods("0000ae014409","140","40","42","6","bp");
goods[123] =new setGoods("0000ae014410","150","40","42","6","bp");
goods[124] =new setGoods("0000ae014411","70","50","42","6","bp");
goods[125] =new setGoods("0000ae014412","80","50","42","6","bp");
goods[126] =new setGoods("0000ae014413","90","50","42","6","bp");
goods[127] =new setGoods("0000ae014414","100","50","42","6","bp");
goods[128] =new setGoods("0000ae014415","110","50","42","6","bp");
goods[129] =new setGoods("0000ae014416","120","50","42","6","bp");
goods[130] =new setGoods("0000ae014417","130","50","42","6","bp");
goods[131] =new setGoods("0000ae014418","140","50","42","6","bp");
goods[132] =new setGoods("0000ae014419","150","50","42","6","bp");
goods[133] =new setGoods("0000ae014420","90","60","42","6","bp");
goods[134] =new setGoods("0000ae014421","100","60","42","6","bp");
goods[135] =new setGoods("0000ae014422","110","60","42","6","bp");
goods[136] =new setGoods("0000ae014423","120","60","42","6","bp");
goods[137] =new setGoods("0000ae014424","130","60","42","6","bp");
goods[138] =new setGoods("0000ae014425","140","60","42","6","bp");
goods[139] =new setGoods("0000ae014426","150","60","42","6","bp");
goods[140] =new setGoods("0000ae014427","110","70","42","6","bp");
goods[141] =new setGoods("0000ae014428","120","70","42","6","bp");
goods[142] =new setGoods("0000ae014429","130","70","42","6","bp");
goods[143] =new setGoods("0000ae014430","140","70","42","6","bp");
goods[144] =new setGoods("0000ae014431","150","70","42","6","bp");
goods[145] =new setGoods("0000ae014432","110","80","42","6","bp");
goods[146] =new setGoods("0000ae014433","120","80","42","6","bp");
goods[147] =new setGoods("0000ae014434","130","80","42","6","bp");
goods[148] =new setGoods("0000ae014435","140","80","42","6","bp");
goods[149] =new setGoods("0000ae014436","150","80","42","6","bp");
goods[150] =new setGoods("0000ae014437","40","40","42","6","bp");
goods[151] =new setGoods("0000ae014438","50","50","42","6","bp");
goods[152] =new setGoods("0000ae014439","60","60","42","6","bp");
goods[153] =new setGoods("0000ae014440","70","70","42","6","bp");
goods[154] =new setGoods("0000ae014441","80","80","42","6","bp");
goods[155] =new setGoods("0000ae014442","90","90","42","6","bp");
goods[156] =new setGoods("0000ae014443","60","30","42","6","gs");
goods[157] =new setGoods("0000ae014444","70","30","42","6","gs");
goods[158] =new setGoods("0000ae014445","80","30","42","6","gs");
goods[159] =new setGoods("0000ae014446","90","30","42","6","gs");
goods[160] =new setGoods("0000ae014447","100","30","42","6","gs");
goods[161] =new setGoods("0000ae014448","110","30","42","6","gs");
goods[162] =new setGoods("0000ae014449","120","30","42","6","gs");
goods[163] =new setGoods("0000ae014450","130","30","42","6","gs");
goods[164] =new setGoods("0000ae014451","140","30","42","6","gs");
goods[165] =new setGoods("0000ae014452","150","30","42","6","gs");
goods[166] =new setGoods("0000ae014453","60","40","42","6","gs");
goods[167] =new setGoods("0000ae014454","70","40","42","6","gs");
goods[168] =new setGoods("0000ae014455","80","40","42","6","gs");
goods[169] =new setGoods("0000ae014456","90","40","42","6","gs");
goods[170] =new setGoods("0000ae014457","100","40","42","6","gs");
goods[171] =new setGoods("0000ae014458","110","40","42","6","gs");
goods[172] =new setGoods("0000ae014459","120","40","42","6","gs");
goods[173] =new setGoods("0000ae014460","130","40","42","6","gs");
goods[174] =new setGoods("0000ae014461","140","40","42","6","gs");
goods[175] =new setGoods("0000ae014462","150","40","42","6","gs");
goods[176] =new setGoods("0000ae014463","70","50","42","6","gs");
goods[177] =new setGoods("0000ae014464","80","50","42","6","gs");
goods[178] =new setGoods("0000ae014465","90","50","42","6","gs");
goods[179] =new setGoods("0000ae014466","100","50","42","6","gs");
goods[180] =new setGoods("0000ae014467","110","50","42","6","gs");
goods[181] =new setGoods("0000ae014468","120","50","42","6","gs");
goods[182] =new setGoods("0000ae014469","130","50","42","6","gs");
goods[183] =new setGoods("0000ae014470","140","50","42","6","gs");
goods[184] =new setGoods("0000ae014471","150","50","42","6","gs");
goods[185] =new setGoods("0000ae014472","90","60","42","6","gs");
goods[186] =new setGoods("0000ae014473","100","60","42","6","gs");
goods[187] =new setGoods("0000ae014474","110","60","42","6","gs");
goods[188] =new setGoods("0000ae014475","120","60","42","6","gs");
goods[189] =new setGoods("0000ae014476","130","60","42","6","gs");
goods[190] =new setGoods("0000ae014477","140","60","42","6","gs");
goods[191] =new setGoods("0000ae014478","150","60","42","6","gs");
goods[192] =new setGoods("0000ae014479","110","70","42","6","gs");
goods[193] =new setGoods("0000ae014480","120","70","42","6","gs");
goods[194] =new setGoods("0000ae014481","130","70","42","6","gs");
goods[195] =new setGoods("0000ae014482","140","70","42","6","gs");
goods[196] =new setGoods("0000ae014483","150","70","42","6","gs");
goods[197] =new setGoods("0000ae014484","110","80","42","6","gs");
goods[198] =new setGoods("0000ae014485","120","80","42","6","gs");
goods[199] =new setGoods("0000ae014486","130","80","42","6","gs");
goods[200] =new setGoods("0000ae014487","140","80","42","6","gs");
goods[201] =new setGoods("0000ae014488","150","80","42","6","gs");
goods[202] =new setGoods("0000ae014489","40","40","42","6","gs");
goods[203] =new setGoods("0000ae014490","50","50","42","6","gs");
goods[204] =new setGoods("0000ae014491","60","60","42","6","gs");
goods[205] =new setGoods("0000ae014492","70","70","42","6","gs");
goods[206] =new setGoods("0000ae014493","80","80","42","6","gs");
goods[207] =new setGoods("0000ae014494","90","90","42","6","gs");
goods[208] =new setGoods("0000ae014495","60","30","42","6","mb");
goods[209] =new setGoods("0000ae014496","70","30","42","6","mb");
goods[210] =new setGoods("0000ae014497","80","30","42","6","mb");
goods[211] =new setGoods("0000ae014498","90","30","42","6","mb");
goods[212] =new setGoods("0000ae014499","100","30","42","6","mb");
goods[213] =new setGoods("0000ae014500","110","30","42","6","mb");
goods[214] =new setGoods("0000ae014501","120","30","42","6","mb");
goods[215] =new setGoods("0000ae014502","130","30","42","6","mb");
goods[216] =new setGoods("0000ae014503","140","30","42","6","mb");
goods[217] =new setGoods("0000ae014504","150","30","42","6","mb");
goods[218] =new setGoods("0000ae014505","60","40","42","6","mb");
goods[219] =new setGoods("0000ae014506","70","40","42","6","mb");
goods[220] =new setGoods("0000ae014507","80","40","42","6","mb");
goods[221] =new setGoods("0000ae014508","90","40","42","6","mb");
goods[222] =new setGoods("0000ae014509","100","40","42","6","mb");
goods[223] =new setGoods("0000ae014510","110","40","42","6","mb");
goods[224] =new setGoods("0000ae014511","120","40","42","6","mb");
goods[225] =new setGoods("0000ae014512","130","40","42","6","mb");
goods[226] =new setGoods("0000ae014513","140","40","42","6","mb");
goods[227] =new setGoods("0000ae014514","150","40","42","6","mb");
goods[228] =new setGoods("0000ae014515","70","50","42","6","mb");
goods[229] =new setGoods("0000ae014516","80","50","42","6","mb");
goods[230] =new setGoods("0000ae014517","90","50","42","6","mb");
goods[231] =new setGoods("0000ae014518","100","50","42","6","mb");
goods[232] =new setGoods("0000ae014519","110","50","42","6","mb");
goods[233] =new setGoods("0000ae014520","120","50","42","6","mb");
goods[234] =new setGoods("0000ae014521","130","50","42","6","mb");
goods[235] =new setGoods("0000ae014522","140","50","42","6","mb");
goods[236] =new setGoods("0000ae014523","150","50","42","6","mb");
goods[237] =new setGoods("0000ae014524","90","60","42","6","mb");
goods[238] =new setGoods("0000ae014525","100","60","42","6","mb");
goods[239] =new setGoods("0000ae014526","110","60","42","6","mb");
goods[240] =new setGoods("0000ae014527","120","60","42","6","mb");
goods[241] =new setGoods("0000ae014528","130","60","42","6","mb");
goods[242] =new setGoods("0000ae014529","140","60","42","6","mb");
goods[243] =new setGoods("0000ae014530","150","60","42","6","mb");
goods[244] =new setGoods("0000ae014531","110","70","42","6","mb");
goods[245] =new setGoods("0000ae014532","120","70","42","6","mb");
goods[246] =new setGoods("0000ae014533","130","70","42","6","mb");
goods[247] =new setGoods("0000ae014534","140","70","42","6","mb");
goods[248] =new setGoods("0000ae014535","150","70","42","6","mb");
goods[249] =new setGoods("0000ae014536","110","80","42","6","mb");
goods[250] =new setGoods("0000ae014537","120","80","42","6","mb");
goods[251] =new setGoods("0000ae014538","130","80","42","6","mb");
goods[252] =new setGoods("0000ae014539","140","80","42","6","mb");
goods[253] =new setGoods("0000ae014540","150","80","42","6","mb");
goods[254] =new setGoods("0000ae014541","40","40","42","6","mb");
goods[255] =new setGoods("0000ae014542","50","50","42","6","mb");
goods[256] =new setGoods("0000ae014543","60","60","42","6","mb");
goods[257] =new setGoods("0000ae014544","70","70","42","6","mb");
goods[258] =new setGoods("0000ae014545","80","80","42","6","mb");
goods[259] =new setGoods("0000ae014546","90","90","42","6","mb");
goods[260] =new setGoods("0000ae014547","60","30","42","6","ww");
goods[261] =new setGoods("0000ae014548","70","30","42","6","ww");
goods[262] =new setGoods("0000ae014549","80","30","42","6","ww");
goods[263] =new setGoods("0000ae014550","90","30","42","6","ww");
goods[264] =new setGoods("0000ae014551","100","30","42","6","ww");
goods[265] =new setGoods("0000ae014552","110","30","42","6","ww");
goods[266] =new setGoods("0000ae014553","120","30","42","6","ww");
goods[267] =new setGoods("0000ae014554","130","30","42","6","ww");
goods[268] =new setGoods("0000ae014555","140","30","42","6","ww");
goods[269] =new setGoods("0000ae014556","150","30","42","6","ww");
goods[270] =new setGoods("0000ae014557","60","40","42","6","ww");
goods[271] =new setGoods("0000ae014558","70","40","42","6","ww");
goods[272] =new setGoods("0000ae014559","80","40","42","6","ww");
goods[273] =new setGoods("0000ae014560","90","40","42","6","ww");
goods[274] =new setGoods("0000ae014561","100","40","42","6","ww");
goods[275] =new setGoods("0000ae014562","110","40","42","6","ww");
goods[276] =new setGoods("0000ae014563","120","40","42","6","ww");
goods[277] =new setGoods("0000ae014564","130","40","42","6","ww");
goods[278] =new setGoods("0000ae014565","140","40","42","6","ww");
goods[279] =new setGoods("0000ae014566","150","40","42","6","ww");
goods[280] =new setGoods("0000ae014567","70","50","42","6","ww");
goods[281] =new setGoods("0000ae014568","80","50","42","6","ww");
goods[282] =new setGoods("0000ae014569","90","50","42","6","ww");
goods[283] =new setGoods("0000ae014570","100","50","42","6","ww");
goods[284] =new setGoods("0000ae014571","110","50","42","6","ww");
goods[285] =new setGoods("0000ae014572","120","50","42","6","ww");
goods[286] =new setGoods("0000ae014573","130","50","42","6","ww");
goods[287] =new setGoods("0000ae014574","140","50","42","6","ww");
goods[288] =new setGoods("0000ae014575","150","50","42","6","ww");
goods[289] =new setGoods("0000ae014576","90","60","42","6","ww");
goods[290] =new setGoods("0000ae014577","100","60","42","6","ww");
goods[291] =new setGoods("0000ae014578","110","60","42","6","ww");
goods[292] =new setGoods("0000ae014579","120","60","42","6","ww");
goods[293] =new setGoods("0000ae014580","130","60","42","6","ww");
goods[294] =new setGoods("0000ae014581","140","60","42","6","ww");
goods[295] =new setGoods("0000ae014582","150","60","42","6","ww");
goods[296] =new setGoods("0000ae014583","110","70","42","6","ww");
goods[297] =new setGoods("0000ae014584","120","70","42","6","ww");
goods[298] =new setGoods("0000ae014585","130","70","42","6","ww");
goods[299] =new setGoods("0000ae014586","140","70","42","6","ww");
goods[300] =new setGoods("0000ae014587","150","70","42","6","ww");
goods[301] =new setGoods("0000ae014588","110","80","42","6","ww");
goods[302] =new setGoods("0000ae014589","120","80","42","6","ww");
goods[303] =new setGoods("0000ae014590","130","80","42","6","ww");
goods[304] =new setGoods("0000ae014591","140","80","42","6","ww");
goods[305] =new setGoods("0000ae014592","150","80","42","6","ww");
goods[306] =new setGoods("0000ae014593","40","40","42","6","ww");
goods[307] =new setGoods("0000ae014594","50","50","42","6","ww");
goods[308] =new setGoods("0000ae014595","60","60","42","6","ww");
goods[309] =new setGoods("0000ae014596","70","70","42","6","ww");
goods[310] =new setGoods("0000ae014597","80","80","42","6","ww");
goods[311] =new setGoods("0000ae014598","90","90","42","6","ww");
goods[312] =new setGoods("0000ae014599","60","30","60","6","nail");
goods[313] =new setGoods("0000ae014600","70","30","60","6","nail");
goods[314] =new setGoods("0000ae014601","80","30","60","6","nail");
goods[315] =new setGoods("0000ae014602","90","30","60","6","nail");
goods[316] =new setGoods("0000ae014603","100","30","60","6","nail");
goods[317] =new setGoods("0000ae014604","110","30","60","6","nail");
goods[318] =new setGoods("0000ae014605","120","30","60","6","nail");
goods[319] =new setGoods("0000ae014606","130","30","60","6","nail");
goods[320] =new setGoods("0000ae014607","140","30","60","6","nail");
goods[321] =new setGoods("0000ae014608","150","30","60","6","nail");
goods[322] =new setGoods("0000ae014609","60","40","60","6","nail");
goods[323] =new setGoods("0000ae014610","70","40","60","6","nail");
goods[324] =new setGoods("0000ae014611","80","40","60","6","nail");
goods[325] =new setGoods("0000ae014612","90","40","60","6","nail");
goods[326] =new setGoods("0000ae014613","100","40","60","6","nail");
goods[327] =new setGoods("0000ae014614","110","40","60","6","nail");
goods[328] =new setGoods("0000ae014615","120","40","60","6","nail");
goods[329] =new setGoods("0000ae014616","130","40","60","6","nail");
goods[330] =new setGoods("0000ae014617","140","40","60","6","nail");
goods[331] =new setGoods("0000ae014618","150","40","60","6","nail");
goods[332] =new setGoods("0000ae014619","70","50","60","6","nail");
goods[333] =new setGoods("0000ae014620","80","50","60","6","nail");
goods[334] =new setGoods("0000ae014621","90","50","60","6","nail");
goods[335] =new setGoods("0000ae014622","100","50","60","6","nail");
goods[336] =new setGoods("0000ae014623","110","50","60","6","nail");
goods[337] =new setGoods("0000ae014624","120","50","60","6","nail");
goods[338] =new setGoods("0000ae014625","130","50","60","6","nail");
goods[339] =new setGoods("0000ae014626","140","50","60","6","nail");
goods[340] =new setGoods("0000ae014627","150","50","60","6","nail");
goods[341] =new setGoods("0000ae014628","90","60","60","6","nail");
goods[342] =new setGoods("0000ae014629","100","60","60","6","nail");
goods[343] =new setGoods("0000ae014630","110","60","60","6","nail");
goods[344] =new setGoods("0000ae014631","120","60","60","6","nail");
goods[345] =new setGoods("0000ae014632","130","60","60","6","nail");
goods[346] =new setGoods("0000ae014633","140","60","60","6","nail");
goods[347] =new setGoods("0000ae014634","150","60","60","6","nail");
goods[348] =new setGoods("0000ae014635","110","70","60","6","nail");
goods[349] =new setGoods("0000ae014636","120","70","60","6","nail");
goods[350] =new setGoods("0000ae014637","130","70","60","6","nail");
goods[351] =new setGoods("0000ae014638","140","70","60","6","nail");
goods[352] =new setGoods("0000ae014639","150","70","60","6","nail");
goods[353] =new setGoods("0000ae014640","110","80","60","6","nail");
goods[354] =new setGoods("0000ae014641","120","80","60","6","nail");
goods[355] =new setGoods("0000ae014642","130","80","60","6","nail");
goods[356] =new setGoods("0000ae014643","140","80","60","6","nail");
goods[357] =new setGoods("0000ae014644","150","80","60","6","nail");
goods[358] =new setGoods("0000ae014645","40","40","60","6","nail");
goods[359] =new setGoods("0000ae014646","50","50","60","6","nail");
goods[360] =new setGoods("0000ae014647","60","60","60","6","nail");
goods[361] =new setGoods("0000ae014648","70","70","60","6","nail");
goods[362] =new setGoods("0000ae014649","80","80","60","6","nail");
goods[363] =new setGoods("0000ae014650","90","90","60","6","nail");
goods[364] =new setGoods("0000ae014651","60","30","60","6","black");
goods[365] =new setGoods("0000ae014652","70","30","60","6","black");
goods[366] =new setGoods("0000ae014653","80","30","60","6","black");
goods[367] =new setGoods("0000ae014654","90","30","60","6","black");
goods[368] =new setGoods("0000ae014655","100","30","60","6","black");
goods[369] =new setGoods("0000ae014656","110","30","60","6","black");
goods[370] =new setGoods("0000ae014657","120","30","60","6","black");
goods[371] =new setGoods("0000ae014658","130","30","60","6","black");
goods[372] =new setGoods("0000ae014659","140","30","60","6","black");
goods[373] =new setGoods("0000ae014660","150","30","60","6","black");
goods[374] =new setGoods("0000ae014661","60","40","60","6","black");
goods[375] =new setGoods("0000ae014662","70","40","60","6","black");
goods[376] =new setGoods("0000ae014663","80","40","60","6","black");
goods[377] =new setGoods("0000ae014664","90","40","60","6","black");
goods[378] =new setGoods("0000ae014665","100","40","60","6","black");
goods[379] =new setGoods("0000ae014666","110","40","60","6","black");
goods[380] =new setGoods("0000ae014667","120","40","60","6","black");
goods[381] =new setGoods("0000ae014668","130","40","60","6","black");
goods[382] =new setGoods("0000ae014669","140","40","60","6","black");
goods[383] =new setGoods("0000ae014670","150","40","60","6","black");
goods[384] =new setGoods("0000ae014671","70","50","60","6","black");
goods[385] =new setGoods("0000ae014672","80","50","60","6","black");
goods[386] =new setGoods("0000ae014673","90","50","60","6","black");
goods[387] =new setGoods("0000ae014674","100","50","60","6","black");
goods[388] =new setGoods("0000ae014675","110","50","60","6","black");
goods[389] =new setGoods("0000ae014676","120","50","60","6","black");
goods[390] =new setGoods("0000ae014677","130","50","60","6","black");
goods[391] =new setGoods("0000ae014678","140","50","60","6","black");
goods[392] =new setGoods("0000ae014679","150","50","60","6","black");
goods[393] =new setGoods("0000ae014680","90","60","60","6","black");
goods[394] =new setGoods("0000ae014681","100","60","60","6","black");
goods[395] =new setGoods("0000ae014682","110","60","60","6","black");
goods[396] =new setGoods("0000ae014683","120","60","60","6","black");
goods[397] =new setGoods("0000ae014684","130","60","60","6","black");
goods[398] =new setGoods("0000ae014685","140","60","60","6","black");
goods[399] =new setGoods("0000ae014686","150","60","60","6","black");
goods[400] =new setGoods("0000ae014687","110","70","60","6","black");
goods[401] =new setGoods("0000ae014688","120","70","60","6","black");
goods[402] =new setGoods("0000ae014689","130","70","60","6","black");
goods[403] =new setGoods("0000ae014690","140","70","60","6","black");
goods[404] =new setGoods("0000ae014691","150","70","60","6","black");
goods[405] =new setGoods("0000ae014692","110","80","60","6","black");
goods[406] =new setGoods("0000ae014693","120","80","60","6","black");
goods[407] =new setGoods("0000ae014694","130","80","60","6","black");
goods[408] =new setGoods("0000ae014695","140","80","60","6","black");
goods[409] =new setGoods("0000ae014696","150","80","60","6","black");
goods[410] =new setGoods("0000ae014697","40","40","60","6","black");
goods[411] =new setGoods("0000ae014698","50","50","60","6","black");
goods[412] =new setGoods("0000ae014699","60","60","60","6","black");
goods[413] =new setGoods("0000ae014700","70","70","60","6","black");
goods[414] =new setGoods("0000ae014701","80","80","60","6","black");
goods[415] =new setGoods("0000ae014702","90","90","60","6","black");
goods[416] =new setGoods("0000ae014703","60","30","60","6","bp");
goods[417] =new setGoods("0000ae014704","70","30","60","6","bp");
goods[418] =new setGoods("0000ae014705","80","30","60","6","bp");
goods[419] =new setGoods("0000ae014706","90","30","60","6","bp");
goods[420] =new setGoods("0000ae014707","100","30","60","6","bp");
goods[421] =new setGoods("0000ae014708","110","30","60","6","bp");
goods[422] =new setGoods("0000ae014709","120","30","60","6","bp");
goods[423] =new setGoods("0000ae014710","130","30","60","6","bp");
goods[424] =new setGoods("0000ae014711","140","30","60","6","bp");
goods[425] =new setGoods("0000ae014712","150","30","60","6","bp");
goods[426] =new setGoods("0000ae014713","60","40","60","6","bp");
goods[427] =new setGoods("0000ae014714","70","40","60","6","bp");
goods[428] =new setGoods("0000ae014715","80","40","60","6","bp");
goods[429] =new setGoods("0000ae014716","90","40","60","6","bp");
goods[430] =new setGoods("0000ae014717","100","40","60","6","bp");
goods[431] =new setGoods("0000ae014718","110","40","60","6","bp");
goods[432] =new setGoods("0000ae014719","120","40","60","6","bp");
goods[433] =new setGoods("0000ae014720","130","40","60","6","bp");
goods[434] =new setGoods("0000ae014721","140","40","60","6","bp");
goods[435] =new setGoods("0000ae014722","150","40","60","6","bp");
goods[436] =new setGoods("0000ae014723","70","50","60","6","bp");
goods[437] =new setGoods("0000ae014724","80","50","60","6","bp");
goods[438] =new setGoods("0000ae014725","90","50","60","6","bp");
goods[439] =new setGoods("0000ae014726","100","50","60","6","bp");
goods[440] =new setGoods("0000ae014727","110","50","60","6","bp");
goods[441] =new setGoods("0000ae014728","120","50","60","6","bp");
goods[442] =new setGoods("0000ae014729","130","50","60","6","bp");
goods[443] =new setGoods("0000ae014730","140","50","60","6","bp");
goods[444] =new setGoods("0000ae014731","150","50","60","6","bp");
goods[445] =new setGoods("0000ae014732","90","60","60","6","bp");
goods[446] =new setGoods("0000ae014733","100","60","60","6","bp");
goods[447] =new setGoods("0000ae014734","110","60","60","6","bp");
goods[448] =new setGoods("0000ae014735","120","60","60","6","bp");
goods[449] =new setGoods("0000ae014736","130","60","60","6","bp");
goods[450] =new setGoods("0000ae014737","140","60","60","6","bp");
goods[451] =new setGoods("0000ae014738","150","60","60","6","bp");
goods[452] =new setGoods("0000ae014739","110","70","60","6","bp");
goods[453] =new setGoods("0000ae014740","120","70","60","6","bp");
goods[454] =new setGoods("0000ae014741","130","70","60","6","bp");
goods[455] =new setGoods("0000ae014742","140","70","60","6","bp");
goods[456] =new setGoods("0000ae014743","150","70","60","6","bp");
goods[457] =new setGoods("0000ae014744","110","80","60","6","bp");
goods[458] =new setGoods("0000ae014745","120","80","60","6","bp");
goods[459] =new setGoods("0000ae014746","130","80","60","6","bp");
goods[460] =new setGoods("0000ae014747","140","80","60","6","bp");
goods[461] =new setGoods("0000ae014748","150","80","60","6","bp");
goods[462] =new setGoods("0000ae014749","40","40","60","6","bp");
goods[463] =new setGoods("0000ae014750","50","50","60","6","bp");
goods[464] =new setGoods("0000ae014751","60","60","60","6","bp");
goods[465] =new setGoods("0000ae014752","70","70","60","6","bp");
goods[466] =new setGoods("0000ae014753","80","80","60","6","bp");
goods[467] =new setGoods("0000ae014754","90","90","60","6","bp");
goods[468] =new setGoods("0000ae014755","60","30","60","6","gs");
goods[469] =new setGoods("0000ae014756","70","30","60","6","gs");
goods[470] =new setGoods("0000ae014757","80","30","60","6","gs");
goods[471] =new setGoods("0000ae014758","90","30","60","6","gs");
goods[472] =new setGoods("0000ae014759","100","30","60","6","gs");
goods[473] =new setGoods("0000ae014760","110","30","60","6","gs");
goods[474] =new setGoods("0000ae014761","120","30","60","6","gs");
goods[475] =new setGoods("0000ae014762","130","30","60","6","gs");
goods[476] =new setGoods("0000ae014763","140","30","60","6","gs");
goods[477] =new setGoods("0000ae014764","150","30","60","6","gs");
goods[478] =new setGoods("0000ae014765","60","40","60","6","gs");
goods[479] =new setGoods("0000ae014766","70","40","60","6","gs");
goods[480] =new setGoods("0000ae014767","80","40","60","6","gs");
goods[481] =new setGoods("0000ae014768","90","40","60","6","gs");
goods[482] =new setGoods("0000ae014769","100","40","60","6","gs");
goods[483] =new setGoods("0000ae014770","110","40","60","6","gs");
goods[484] =new setGoods("0000ae014771","120","40","60","6","gs");
goods[485] =new setGoods("0000ae014772","130","40","60","6","gs");
goods[486] =new setGoods("0000ae014773","140","40","60","6","gs");
goods[487] =new setGoods("0000ae014774","150","40","60","6","gs");
goods[488] =new setGoods("0000ae014775","70","50","60","6","gs");
goods[489] =new setGoods("0000ae014776","80","50","60","6","gs");
goods[490] =new setGoods("0000ae014777","90","50","60","6","gs");
goods[491] =new setGoods("0000ae014778","100","50","60","6","gs");
goods[492] =new setGoods("0000ae014779","110","50","60","6","gs");
goods[493] =new setGoods("0000ae014780","120","50","60","6","gs");
goods[494] =new setGoods("0000ae014781","130","50","60","6","gs");
goods[495] =new setGoods("0000ae014782","140","50","60","6","gs");
goods[496] =new setGoods("0000ae014783","150","50","60","6","gs");
goods[497] =new setGoods("0000ae014784","90","60","60","6","gs");
goods[498] =new setGoods("0000ae014785","100","60","60","6","gs");
goods[499] =new setGoods("0000ae014786","110","60","60","6","gs");
goods[500] =new setGoods("0000ae014787","120","60","60","6","gs");
goods[501] =new setGoods("0000ae014788","130","60","60","6","gs");
goods[502] =new setGoods("0000ae014789","140","60","60","6","gs");
goods[503] =new setGoods("0000ae014790","150","60","60","6","gs");
goods[504] =new setGoods("0000ae014791","110","70","60","6","gs");
goods[505] =new setGoods("0000ae014792","120","70","60","6","gs");
goods[506] =new setGoods("0000ae014793","130","70","60","6","gs");
goods[507] =new setGoods("0000ae014794","140","70","60","6","gs");
goods[508] =new setGoods("0000ae014795","150","70","60","6","gs");
goods[509] =new setGoods("0000ae014796","110","80","60","6","gs");
goods[510] =new setGoods("0000ae014797","120","80","60","6","gs");
goods[511] =new setGoods("0000ae014798","130","80","60","6","gs");
goods[512] =new setGoods("0000ae014799","140","80","60","6","gs");
goods[513] =new setGoods("0000ae014800","150","80","60","6","gs");
goods[514] =new setGoods("0000ae014801","40","40","60","6","gs");
goods[515] =new setGoods("0000ae014802","50","50","60","6","gs");
goods[516] =new setGoods("0000ae014803","60","60","60","6","gs");
goods[517] =new setGoods("0000ae014804","70","70","60","6","gs");
goods[518] =new setGoods("0000ae014805","80","80","60","6","gs");
goods[519] =new setGoods("0000ae014806","90","90","60","6","gs");
goods[520] =new setGoods("0000ae014807","60","30","60","6","mb");
goods[521] =new setGoods("0000ae014808","70","30","60","6","mb");
goods[522] =new setGoods("0000ae014809","80","30","60","6","mb");
goods[523] =new setGoods("0000ae014810","90","30","60","6","mb");
goods[524] =new setGoods("0000ae014811","100","30","60","6","mb");
goods[525] =new setGoods("0000ae014812","110","30","60","6","mb");
goods[526] =new setGoods("0000ae014813","120","30","60","6","mb");
goods[527] =new setGoods("0000ae014814","130","30","60","6","mb");
goods[528] =new setGoods("0000ae014815","140","30","60","6","mb");
goods[529] =new setGoods("0000ae014816","150","30","60","6","mb");
goods[530] =new setGoods("0000ae014817","60","40","60","6","mb");
goods[531] =new setGoods("0000ae014818","70","40","60","6","mb");
goods[532] =new setGoods("0000ae014819","80","40","60","6","mb");
goods[533] =new setGoods("0000ae014820","90","40","60","6","mb");
goods[534] =new setGoods("0000ae014821","100","40","60","6","mb");
goods[535] =new setGoods("0000ae014822","110","40","60","6","mb");
goods[536] =new setGoods("0000ae014823","120","40","60","6","mb");
goods[537] =new setGoods("0000ae014824","130","40","60","6","mb");
goods[538] =new setGoods("0000ae014825","140","40","60","6","mb");
goods[539] =new setGoods("0000ae014826","150","40","60","6","mb");
goods[540] =new setGoods("0000ae014827","70","50","60","6","mb");
goods[541] =new setGoods("0000ae014828","80","50","60","6","mb");
goods[542] =new setGoods("0000ae014829","90","50","60","6","mb");
goods[543] =new setGoods("0000ae014830","100","50","60","6","mb");
goods[544] =new setGoods("0000ae014831","110","50","60","6","mb");
goods[545] =new setGoods("0000ae014832","120","50","60","6","mb");
goods[546] =new setGoods("0000ae014833","130","50","60","6","mb");
goods[547] =new setGoods("0000ae014834","140","50","60","6","mb");
goods[548] =new setGoods("0000ae014835","150","50","60","6","mb");
goods[549] =new setGoods("0000ae014836","90","60","60","6","mb");
goods[550] =new setGoods("0000ae014837","100","60","60","6","mb");
goods[551] =new setGoods("0000ae014838","110","60","60","6","mb");
goods[552] =new setGoods("0000ae014839","120","60","60","6","mb");
goods[553] =new setGoods("0000ae014840","130","60","60","6","mb");
goods[554] =new setGoods("0000ae014841","140","60","60","6","mb");
goods[555] =new setGoods("0000ae014842","150","60","60","6","mb");
goods[556] =new setGoods("0000ae014843","110","70","60","6","mb");
goods[557] =new setGoods("0000ae014844","120","70","60","6","mb");
goods[558] =new setGoods("0000ae014845","130","70","60","6","mb");
goods[559] =new setGoods("0000ae014846","140","70","60","6","mb");
goods[560] =new setGoods("0000ae014847","150","70","60","6","mb");
goods[561] =new setGoods("0000ae014848","110","80","60","6","mb");
goods[562] =new setGoods("0000ae014849","120","80","60","6","mb");
goods[563] =new setGoods("0000ae014850","130","80","60","6","mb");
goods[564] =new setGoods("0000ae014851","140","80","60","6","mb");
goods[565] =new setGoods("0000ae014852","150","80","60","6","mb");
goods[566] =new setGoods("0000ae014853","40","40","60","6","mb");
goods[567] =new setGoods("0000ae014854","50","50","60","6","mb");
goods[568] =new setGoods("0000ae014855","60","60","60","6","mb");
goods[569] =new setGoods("0000ae014856","70","70","60","6","mb");
goods[570] =new setGoods("0000ae014857","80","80","60","6","mb");
goods[571] =new setGoods("0000ae014858","90","90","60","6","mb");
goods[572] =new setGoods("0000ae014859","60","30","60","6","ww");
goods[573] =new setGoods("0000ae014860","70","30","60","6","ww");
goods[574] =new setGoods("0000ae014861","80","30","60","6","ww");
goods[575] =new setGoods("0000ae014862","90","30","60","6","ww");
goods[576] =new setGoods("0000ae014863","100","30","60","6","ww");
goods[577] =new setGoods("0000ae014864","110","30","60","6","ww");
goods[578] =new setGoods("0000ae014865","120","30","60","6","ww");
goods[579] =new setGoods("0000ae014866","130","30","60","6","ww");
goods[580] =new setGoods("0000ae014867","140","30","60","6","ww");
goods[581] =new setGoods("0000ae014868","150","30","60","6","ww");
goods[582] =new setGoods("0000ae014869","60","40","60","6","ww");
goods[583] =new setGoods("0000ae014870","70","40","60","6","ww");
goods[584] =new setGoods("0000ae014871","80","40","60","6","ww");
goods[585] =new setGoods("0000ae014872","90","40","60","6","ww");
goods[586] =new setGoods("0000ae014873","100","40","60","6","ww");
goods[587] =new setGoods("0000ae014874","110","40","60","6","ww");
goods[588] =new setGoods("0000ae014875","120","40","60","6","ww");
goods[589] =new setGoods("0000ae014876","130","40","60","6","ww");
goods[590] =new setGoods("0000ae014877","140","40","60","6","ww");
goods[591] =new setGoods("0000ae014878","150","40","60","6","ww");
goods[592] =new setGoods("0000ae014879","70","50","60","6","ww");
goods[593] =new setGoods("0000ae014880","80","50","60","6","ww");
goods[594] =new setGoods("0000ae014881","90","50","60","6","ww");
goods[595] =new setGoods("0000ae014882","100","50","60","6","ww");
goods[596] =new setGoods("0000ae014883","110","50","60","6","ww");
goods[597] =new setGoods("0000ae014884","120","50","60","6","ww");
goods[598] =new setGoods("0000ae014885","130","50","60","6","ww");
goods[599] =new setGoods("0000ae014886","140","50","60","6","ww");
goods[600] =new setGoods("0000ae014887","150","50","60","6","ww");
goods[601] =new setGoods("0000ae014888","90","60","60","6","ww");
goods[602] =new setGoods("0000ae014889","100","60","60","6","ww");
goods[603] =new setGoods("0000ae014890","110","60","60","6","ww");
goods[604] =new setGoods("0000ae014891","120","60","60","6","ww");
goods[605] =new setGoods("0000ae014892","130","60","60","6","ww");
goods[606] =new setGoods("0000ae014893","140","60","60","6","ww");
goods[607] =new setGoods("0000ae014894","150","60","60","6","ww");
goods[608] =new setGoods("0000ae014895","110","70","60","6","ww");
goods[609] =new setGoods("0000ae014896","120","70","60","6","ww");
goods[610] =new setGoods("0000ae014897","130","70","60","6","ww");
goods[611] =new setGoods("0000ae014898","140","70","60","6","ww");
goods[612] =new setGoods("0000ae014899","150","70","60","6","ww");
goods[613] =new setGoods("0000ae014900","110","80","60","6","ww");
goods[614] =new setGoods("0000ae014901","120","80","60","6","ww");
goods[615] =new setGoods("0000ae014902","130","80","60","6","ww");
goods[616] =new setGoods("0000ae014903","140","80","60","6","ww");
goods[617] =new setGoods("0000ae014904","150","80","60","6","ww");
goods[618] =new setGoods("0000ae014905","40","40","60","6","ww");
goods[619] =new setGoods("0000ae014906","50","50","60","6","ww");
goods[620] =new setGoods("0000ae014907","60","60","60","6","ww");
goods[621] =new setGoods("0000ae014908","70","70","60","6","ww");
goods[622] =new setGoods("0000ae014909","80","80","60","6","ww");
goods[623] =new setGoods("0000ae014910","90","90","60","6","ww");
goods[624] =new setGoods("0000ae014911","60","30","72","6","nail");
goods[625] =new setGoods("0000ae014912","70","30","72","6","nail");
goods[626] =new setGoods("0000ae014913","80","30","72","6","nail");
goods[627] =new setGoods("0000ae014914","90","30","72","6","nail");
goods[628] =new setGoods("0000ae014915","100","30","72","6","nail");
goods[629] =new setGoods("0000ae014916","110","30","72","6","nail");
goods[630] =new setGoods("0000ae014917","120","30","72","6","nail");
goods[631] =new setGoods("0000ae014918","130","30","72","6","nail");
goods[632] =new setGoods("0000ae014919","140","30","72","6","nail");
goods[633] =new setGoods("0000ae014920","150","30","72","6","nail");
goods[634] =new setGoods("0000ae014921","60","40","72","6","nail");
goods[635] =new setGoods("0000ae014922","70","40","72","6","nail");
goods[636] =new setGoods("0000ae014923","80","40","72","6","nail");
goods[637] =new setGoods("0000ae014924","90","40","72","6","nail");
goods[638] =new setGoods("0000ae014925","100","40","72","6","nail");
goods[639] =new setGoods("0000ae014926","110","40","72","6","nail");
goods[640] =new setGoods("0000ae014927","120","40","72","6","nail");
goods[641] =new setGoods("0000ae014928","130","40","72","6","nail");
goods[642] =new setGoods("0000ae014929","140","40","72","6","nail");
goods[643] =new setGoods("0000ae014930","150","40","72","6","nail");
goods[644] =new setGoods("0000ae014931","70","50","72","6","nail");
goods[645] =new setGoods("0000ae014932","80","50","72","6","nail");
goods[646] =new setGoods("0000ae014933","90","50","72","6","nail");
goods[647] =new setGoods("0000ae014934","100","50","72","6","nail");
goods[648] =new setGoods("0000ae014935","110","50","72","6","nail");
goods[649] =new setGoods("0000ae014936","120","50","72","6","nail");
goods[650] =new setGoods("0000ae014937","130","50","72","6","nail");
goods[651] =new setGoods("0000ae014938","140","50","72","6","nail");
goods[652] =new setGoods("0000ae014939","150","50","72","6","nail");
goods[653] =new setGoods("0000ae014940","90","60","72","6","nail");
goods[654] =new setGoods("0000ae014941","100","60","72","6","nail");
goods[655] =new setGoods("0000ae014942","110","60","72","6","nail");
goods[656] =new setGoods("0000ae014943","120","60","72","6","nail");
goods[657] =new setGoods("0000ae014944","130","60","72","6","nail");
goods[658] =new setGoods("0000ae014945","140","60","72","6","nail");
goods[659] =new setGoods("0000ae014946","150","60","72","6","nail");
goods[660] =new setGoods("0000ae014947","110","70","72","6","nail");
goods[661] =new setGoods("0000ae014948","120","70","72","6","nail");
goods[662] =new setGoods("0000ae014949","130","70","72","6","nail");
goods[663] =new setGoods("0000ae014950","140","70","72","6","nail");
goods[664] =new setGoods("0000ae014951","150","70","72","6","nail");
goods[665] =new setGoods("0000ae014952","110","80","72","6","nail");
goods[666] =new setGoods("0000ae014953","120","80","72","6","nail");
goods[667] =new setGoods("0000ae014954","130","80","72","6","nail");
goods[668] =new setGoods("0000ae014955","140","80","72","6","nail");
goods[669] =new setGoods("0000ae014956","150","80","72","6","nail");
goods[670] =new setGoods("0000ae014957","40","40","72","6","nail");
goods[671] =new setGoods("0000ae014958","50","50","72","6","nail");
goods[672] =new setGoods("0000ae014959","60","60","72","6","nail");
goods[673] =new setGoods("0000ae014960","70","70","72","6","nail");
goods[674] =new setGoods("0000ae014961","80","80","72","6","nail");
goods[675] =new setGoods("0000ae014962","90","90","72","6","nail");
goods[676] =new setGoods("0000ae014963","60","30","72","6","black");
goods[677] =new setGoods("0000ae014964","70","30","72","6","black");
goods[678] =new setGoods("0000ae014965","80","30","72","6","black");
goods[679] =new setGoods("0000ae014966","90","30","72","6","black");
goods[680] =new setGoods("0000ae014967","100","30","72","6","black");
goods[681] =new setGoods("0000ae014968","110","30","72","6","black");
goods[682] =new setGoods("0000ae014969","120","30","72","6","black");
goods[683] =new setGoods("0000ae014970","130","30","72","6","black");
goods[684] =new setGoods("0000ae014971","140","30","72","6","black");
goods[685] =new setGoods("0000ae014972","150","30","72","6","black");
goods[686] =new setGoods("0000ae014973","60","40","72","6","black");
goods[687] =new setGoods("0000ae014974","70","40","72","6","black");
goods[688] =new setGoods("0000ae014975","80","40","72","6","black");
goods[689] =new setGoods("0000ae014976","90","40","72","6","black");
goods[690] =new setGoods("0000ae014977","100","40","72","6","black");
goods[691] =new setGoods("0000ae014978","110","40","72","6","black");
goods[692] =new setGoods("0000ae014979","120","40","72","6","black");
goods[693] =new setGoods("0000ae014980","130","40","72","6","black");
goods[694] =new setGoods("0000ae014981","140","40","72","6","black");
goods[695] =new setGoods("0000ae014982","150","40","72","6","black");
goods[696] =new setGoods("0000ae014983","70","50","72","6","black");
goods[697] =new setGoods("0000ae014984","80","50","72","6","black");
goods[698] =new setGoods("0000ae014985","90","50","72","6","black");
goods[699] =new setGoods("0000ae014986","100","50","72","6","black");
goods[700] =new setGoods("0000ae014987","110","50","72","6","black");
goods[701] =new setGoods("0000ae014988","120","50","72","6","black");
goods[702] =new setGoods("0000ae014989","130","50","72","6","black");
goods[703] =new setGoods("0000ae014990","140","50","72","6","black");
goods[704] =new setGoods("0000ae014991","150","50","72","6","black");
goods[705] =new setGoods("0000ae014992","90","60","72","6","black");
goods[706] =new setGoods("0000ae014993","100","60","72","6","black");
goods[707] =new setGoods("0000ae014994","110","60","72","6","black");
goods[708] =new setGoods("0000ae014995","120","60","72","6","black");
goods[709] =new setGoods("0000ae014996","130","60","72","6","black");
goods[710] =new setGoods("0000ae014997","140","60","72","6","black");
goods[711] =new setGoods("0000ae014998","150","60","72","6","black");
goods[712] =new setGoods("0000ae014999","110","70","72","6","black");
goods[713] =new setGoods("0000ae015000","120","70","72","6","black");
goods[714] =new setGoods("0000ae015001","130","70","72","6","black");
goods[715] =new setGoods("0000ae015002","140","70","72","6","black");
goods[716] =new setGoods("0000ae015003","150","70","72","6","black");
goods[717] =new setGoods("0000ae015004","110","80","72","6","black");
goods[718] =new setGoods("0000ae015005","120","80","72","6","black");
goods[719] =new setGoods("0000ae015006","130","80","72","6","black");
goods[720] =new setGoods("0000ae015007","140","80","72","6","black");
goods[721] =new setGoods("0000ae015008","150","80","72","6","black");
goods[722] =new setGoods("0000ae015009","40","40","72","6","black");
goods[723] =new setGoods("0000ae015010","50","50","72","6","black");
goods[724] =new setGoods("0000ae015011","60","60","72","6","black");
goods[725] =new setGoods("0000ae015012","70","70","72","6","black");
goods[726] =new setGoods("0000ae015013","80","80","72","6","black");
goods[727] =new setGoods("0000ae015014","90","90","72","6","black");
goods[728] =new setGoods("0000ae015015","60","30","72","6","bp");
goods[729] =new setGoods("0000ae015016","70","30","72","6","bp");
goods[730] =new setGoods("0000ae015017","80","30","72","6","bp");
goods[731] =new setGoods("0000ae015018","90","30","72","6","bp");
goods[732] =new setGoods("0000ae015019","100","30","72","6","bp");
goods[733] =new setGoods("0000ae015020","110","30","72","6","bp");
goods[734] =new setGoods("0000ae015021","120","30","72","6","bp");
goods[735] =new setGoods("0000ae015022","130","30","72","6","bp");
goods[736] =new setGoods("0000ae015023","140","30","72","6","bp");
goods[737] =new setGoods("0000ae015024","150","30","72","6","bp");
goods[738] =new setGoods("0000ae015025","60","40","72","6","bp");
goods[739] =new setGoods("0000ae015026","70","40","72","6","bp");
goods[740] =new setGoods("0000ae015027","80","40","72","6","bp");
goods[741] =new setGoods("0000ae015028","90","40","72","6","bp");
goods[742] =new setGoods("0000ae015029","100","40","72","6","bp");
goods[743] =new setGoods("0000ae015030","110","40","72","6","bp");
goods[744] =new setGoods("0000ae015031","120","40","72","6","bp");
goods[745] =new setGoods("0000ae015032","130","40","72","6","bp");
goods[746] =new setGoods("0000ae015033","140","40","72","6","bp");
goods[747] =new setGoods("0000ae015034","150","40","72","6","bp");
goods[748] =new setGoods("0000ae015035","70","50","72","6","bp");
goods[749] =new setGoods("0000ae015036","80","50","72","6","bp");
goods[750] =new setGoods("0000ae015037","90","50","72","6","bp");
goods[751] =new setGoods("0000ae015038","100","50","72","6","bp");
goods[752] =new setGoods("0000ae015039","110","50","72","6","bp");
goods[753] =new setGoods("0000ae015040","120","50","72","6","bp");
goods[754] =new setGoods("0000ae015041","130","50","72","6","bp");
goods[755] =new setGoods("0000ae015042","140","50","72","6","bp");
goods[756] =new setGoods("0000ae015043","150","50","72","6","bp");
goods[757] =new setGoods("0000ae015044","90","60","72","6","bp");
goods[758] =new setGoods("0000ae015045","100","60","72","6","bp");
goods[759] =new setGoods("0000ae015046","110","60","72","6","bp");
goods[760] =new setGoods("0000ae015047","120","60","72","6","bp");
goods[761] =new setGoods("0000ae015048","130","60","72","6","bp");
goods[762] =new setGoods("0000ae015049","140","60","72","6","bp");
goods[763] =new setGoods("0000ae015050","150","60","72","6","bp");
goods[764] =new setGoods("0000ae015051","110","70","72","6","bp");
goods[765] =new setGoods("0000ae015052","120","70","72","6","bp");
goods[766] =new setGoods("0000ae015053","130","70","72","6","bp");
goods[767] =new setGoods("0000ae015054","140","70","72","6","bp");
goods[768] =new setGoods("0000ae015055","150","70","72","6","bp");
goods[769] =new setGoods("0000ae015056","110","80","72","6","bp");
goods[770] =new setGoods("0000ae015057","120","80","72","6","bp");
goods[771] =new setGoods("0000ae015058","130","80","72","6","bp");
goods[772] =new setGoods("0000ae015059","140","80","72","6","bp");
goods[773] =new setGoods("0000ae015060","150","80","72","6","bp");
goods[774] =new setGoods("0000ae015061","40","40","72","6","bp");
goods[775] =new setGoods("0000ae015062","50","50","72","6","bp");
goods[776] =new setGoods("0000ae015063","60","60","72","6","bp");
goods[777] =new setGoods("0000ae015064","70","70","72","6","bp");
goods[778] =new setGoods("0000ae015065","80","80","72","6","bp");
goods[779] =new setGoods("0000ae015066","90","90","72","6","bp");
goods[780] =new setGoods("0000ae015067","60","30","72","6","gs");
goods[781] =new setGoods("0000ae015068","70","30","72","6","gs");
goods[782] =new setGoods("0000ae015069","80","30","72","6","gs");
goods[783] =new setGoods("0000ae015070","90","30","72","6","gs");
goods[784] =new setGoods("0000ae015071","100","30","72","6","gs");
goods[785] =new setGoods("0000ae015072","110","30","72","6","gs");
goods[786] =new setGoods("0000ae015073","120","30","72","6","gs");
goods[787] =new setGoods("0000ae015074","130","30","72","6","gs");
goods[788] =new setGoods("0000ae015075","140","30","72","6","gs");
goods[789] =new setGoods("0000ae015076","150","30","72","6","gs");
goods[790] =new setGoods("0000ae015077","60","40","72","6","gs");
goods[791] =new setGoods("0000ae015078","70","40","72","6","gs");
goods[792] =new setGoods("0000ae015079","80","40","72","6","gs");
goods[793] =new setGoods("0000ae015080","90","40","72","6","gs");
goods[794] =new setGoods("0000ae015081","100","40","72","6","gs");
goods[795] =new setGoods("0000ae015082","110","40","72","6","gs");
goods[796] =new setGoods("0000ae015083","120","40","72","6","gs");
goods[797] =new setGoods("0000ae015084","130","40","72","6","gs");
goods[798] =new setGoods("0000ae015085","140","40","72","6","gs");
goods[799] =new setGoods("0000ae015086","150","40","72","6","gs");
goods[800] =new setGoods("0000ae015087","70","50","72","6","gs");
goods[801] =new setGoods("0000ae015088","80","50","72","6","gs");
goods[802] =new setGoods("0000ae015089","90","50","72","6","gs");
goods[803] =new setGoods("0000ae015090","100","50","72","6","gs");
goods[804] =new setGoods("0000ae015091","110","50","72","6","gs");
goods[805] =new setGoods("0000ae015092","120","50","72","6","gs");
goods[806] =new setGoods("0000ae015093","130","50","72","6","gs");
goods[807] =new setGoods("0000ae015094","140","50","72","6","gs");
goods[808] =new setGoods("0000ae015095","150","50","72","6","gs");
goods[809] =new setGoods("0000ae015096","90","60","72","6","gs");
goods[810] =new setGoods("0000ae015097","100","60","72","6","gs");
goods[811] =new setGoods("0000ae015098","110","60","72","6","gs");
goods[812] =new setGoods("0000ae015099","120","60","72","6","gs");
goods[813] =new setGoods("0000ae015100","130","60","72","6","gs");
goods[814] =new setGoods("0000ae015101","140","60","72","6","gs");
goods[815] =new setGoods("0000ae015102","150","60","72","6","gs");
goods[816] =new setGoods("0000ae015103","110","70","72","6","gs");
goods[817] =new setGoods("0000ae015104","120","70","72","6","gs");
goods[818] =new setGoods("0000ae015105","130","70","72","6","gs");
goods[819] =new setGoods("0000ae015106","140","70","72","6","gs");
goods[820] =new setGoods("0000ae015107","150","70","72","6","gs");
goods[821] =new setGoods("0000ae015108","110","80","72","6","gs");
goods[822] =new setGoods("0000ae015109","120","80","72","6","gs");
goods[823] =new setGoods("0000ae015110","130","80","72","6","gs");
goods[824] =new setGoods("0000ae015111","140","80","72","6","gs");
goods[825] =new setGoods("0000ae015112","150","80","72","6","gs");
goods[826] =new setGoods("0000ae015113","40","40","72","6","gs");
goods[827] =new setGoods("0000ae015114","50","50","72","6","gs");
goods[828] =new setGoods("0000ae015115","60","60","72","6","gs");
goods[829] =new setGoods("0000ae015116","70","70","72","6","gs");
goods[830] =new setGoods("0000ae015117","80","80","72","6","gs");
goods[831] =new setGoods("0000ae015118","90","90","72","6","gs");
goods[832] =new setGoods("0000ae015119","60","30","72","6","mb");
goods[833] =new setGoods("0000ae015120","70","30","72","6","mb");
goods[834] =new setGoods("0000ae015121","80","30","72","6","mb");
goods[835] =new setGoods("0000ae015122","90","30","72","6","mb");
goods[836] =new setGoods("0000ae015123","100","30","72","6","mb");
goods[837] =new setGoods("0000ae015124","110","30","72","6","mb");
goods[838] =new setGoods("0000ae015125","120","30","72","6","mb");
goods[839] =new setGoods("0000ae015126","130","30","72","6","mb");
goods[840] =new setGoods("0000ae015127","140","30","72","6","mb");
goods[841] =new setGoods("0000ae015128","150","30","72","6","mb");
goods[842] =new setGoods("0000ae015129","60","40","72","6","mb");
goods[843] =new setGoods("0000ae015130","70","40","72","6","mb");
goods[844] =new setGoods("0000ae015131","80","40","72","6","mb");
goods[845] =new setGoods("0000ae015132","90","40","72","6","mb");
goods[846] =new setGoods("0000ae015133","100","40","72","6","mb");
goods[847] =new setGoods("0000ae015134","110","40","72","6","mb");
goods[848] =new setGoods("0000ae015135","120","40","72","6","mb");
goods[849] =new setGoods("0000ae015136","130","40","72","6","mb");
goods[850] =new setGoods("0000ae015137","140","40","72","6","mb");
goods[851] =new setGoods("0000ae015138","150","40","72","6","mb");
goods[852] =new setGoods("0000ae015139","70","50","72","6","mb");
goods[853] =new setGoods("0000ae015140","80","50","72","6","mb");
goods[854] =new setGoods("0000ae015141","90","50","72","6","mb");
goods[855] =new setGoods("0000ae015142","100","50","72","6","mb");
goods[856] =new setGoods("0000ae015143","110","50","72","6","mb");
goods[857] =new setGoods("0000ae015144","120","50","72","6","mb");
goods[858] =new setGoods("0000ae015145","130","50","72","6","mb");
goods[859] =new setGoods("0000ae015146","140","50","72","6","mb");
goods[860] =new setGoods("0000ae015147","150","50","72","6","mb");
goods[861] =new setGoods("0000ae015148","90","60","72","6","mb");
goods[862] =new setGoods("0000ae015149","100","60","72","6","mb");
goods[863] =new setGoods("0000ae015150","110","60","72","6","mb");
goods[864] =new setGoods("0000ae015151","120","60","72","6","mb");
goods[865] =new setGoods("0000ae015152","130","60","72","6","mb");
goods[866] =new setGoods("0000ae015153","140","60","72","6","mb");
goods[867] =new setGoods("0000ae015154","150","60","72","6","mb");
goods[868] =new setGoods("0000ae015155","110","70","72","6","mb");
goods[869] =new setGoods("0000ae015156","120","70","72","6","mb");
goods[870] =new setGoods("0000ae015157","130","70","72","6","mb");
goods[871] =new setGoods("0000ae015158","140","70","72","6","mb");
goods[872] =new setGoods("0000ae015159","150","70","72","6","mb");
goods[873] =new setGoods("0000ae015160","110","80","72","6","mb");
goods[874] =new setGoods("0000ae015161","120","80","72","6","mb");
goods[875] =new setGoods("0000ae015162","130","80","72","6","mb");
goods[876] =new setGoods("0000ae015163","140","80","72","6","mb");
goods[877] =new setGoods("0000ae015164","150","80","72","6","mb");
goods[878] =new setGoods("0000ae015165","40","40","72","6","mb");
goods[879] =new setGoods("0000ae015166","50","50","72","6","mb");
goods[880] =new setGoods("0000ae015167","60","60","72","6","mb");
goods[881] =new setGoods("0000ae015168","70","70","72","6","mb");
goods[882] =new setGoods("0000ae015169","80","80","72","6","mb");
goods[883] =new setGoods("0000ae015170","90","90","72","6","mb");
goods[884] =new setGoods("0000ae015171","60","30","72","6","ww");
goods[885] =new setGoods("0000ae015172","70","30","72","6","ww");
goods[886] =new setGoods("0000ae015173","80","30","72","6","ww");
goods[887] =new setGoods("0000ae015174","90","30","72","6","ww");
goods[888] =new setGoods("0000ae015175","100","30","72","6","ww");
goods[889] =new setGoods("0000ae015176","110","30","72","6","ww");
goods[890] =new setGoods("0000ae015177","120","30","72","6","ww");
goods[891] =new setGoods("0000ae015178","130","30","72","6","ww");
goods[892] =new setGoods("0000ae015179","140","30","72","6","ww");
goods[893] =new setGoods("0000ae015180","150","30","72","6","ww");
goods[894] =new setGoods("0000ae015181","60","40","72","6","ww");
goods[895] =new setGoods("0000ae015182","70","40","72","6","ww");
goods[896] =new setGoods("0000ae015183","80","40","72","6","ww");
goods[897] =new setGoods("0000ae015184","90","40","72","6","ww");
goods[898] =new setGoods("0000ae015185","100","40","72","6","ww");
goods[899] =new setGoods("0000ae015186","110","40","72","6","ww");
goods[900] =new setGoods("0000ae015187","120","40","72","6","ww");
goods[901] =new setGoods("0000ae015188","130","40","72","6","ww");
goods[902] =new setGoods("0000ae015189","140","40","72","6","ww");
goods[903] =new setGoods("0000ae015190","150","40","72","6","ww");
goods[904] =new setGoods("0000ae015191","70","50","72","6","ww");
goods[905] =new setGoods("0000ae015192","80","50","72","6","ww");
goods[906] =new setGoods("0000ae015193","90","50","72","6","ww");
goods[907] =new setGoods("0000ae015194","100","50","72","6","ww");
goods[908] =new setGoods("0000ae015195","110","50","72","6","ww");
goods[909] =new setGoods("0000ae015196","120","50","72","6","ww");
goods[910] =new setGoods("0000ae015197","130","50","72","6","ww");
goods[911] =new setGoods("0000ae015198","140","50","72","6","ww");
goods[912] =new setGoods("0000ae015199","150","50","72","6","ww");
goods[913] =new setGoods("0000ae015200","90","60","72","6","ww");
goods[914] =new setGoods("0000ae015201","100","60","72","6","ww");
goods[915] =new setGoods("0000ae015202","110","60","72","6","ww");
goods[916] =new setGoods("0000ae015203","120","60","72","6","ww");
goods[917] =new setGoods("0000ae015204","130","60","72","6","ww");
goods[918] =new setGoods("0000ae015205","140","60","72","6","ww");
goods[919] =new setGoods("0000ae015206","150","60","72","6","ww");
goods[920] =new setGoods("0000ae015207","110","70","72","6","ww");
goods[921] =new setGoods("0000ae015208","120","70","72","6","ww");
goods[922] =new setGoods("0000ae015209","130","70","72","6","ww");
goods[923] =new setGoods("0000ae015210","140","70","72","6","ww");
goods[924] =new setGoods("0000ae015211","150","70","72","6","ww");
goods[925] =new setGoods("0000ae015212","110","80","72","6","ww");
goods[926] =new setGoods("0000ae015213","120","80","72","6","ww");
goods[927] =new setGoods("0000ae015214","130","80","72","6","ww");
goods[928] =new setGoods("0000ae015215","140","80","72","6","ww");
goods[929] =new setGoods("0000ae015216","150","80","72","6","ww");
goods[930] =new setGoods("0000ae015217","40","40","72","6","ww");
goods[931] =new setGoods("0000ae015218","50","50","72","6","ww");
goods[932] =new setGoods("0000ae015219","60","60","72","6","ww");
goods[933] =new setGoods("0000ae015220","70","70","72","6","ww");
goods[934] =new setGoods("0000ae015221","80","80","72","6","ww");
goods[935] =new setGoods("0000ae015222","90","90","72","6","ww");
goods[936] =new setGoods("0000ae015223","60","40","90","6","nail");
goods[937] =new setGoods("0000ae015224","70","40","90","6","nail");
goods[938] =new setGoods("0000ae015225","80","40","90","6","nail");
goods[939] =new setGoods("0000ae015226","90","40","90","6","nail");
goods[940] =new setGoods("0000ae015227","100","40","90","6","nail");
goods[941] =new setGoods("0000ae015228","110","40","90","6","nail");
goods[942] =new setGoods("0000ae015229","120","40","90","6","nail");
goods[943] =new setGoods("0000ae015230","130","40","90","6","nail");
goods[944] =new setGoods("0000ae015231","140","40","90","6","nail");
goods[945] =new setGoods("0000ae015232","150","40","90","6","nail");
goods[946] =new setGoods("0000ae015233","60","50","90","6","nail");
goods[947] =new setGoods("0000ae015234","70","50","90","6","nail");
goods[948] =new setGoods("0000ae015235","80","50","90","6","nail");
goods[949] =new setGoods("0000ae015236","90","50","90","6","nail");
goods[950] =new setGoods("0000ae015237","100","50","90","6","nail");
goods[951] =new setGoods("0000ae015238","110","50","90","6","nail");
goods[952] =new setGoods("0000ae015239","120","50","90","6","nail");
goods[953] =new setGoods("0000ae015240","130","50","90","6","nail");
goods[954] =new setGoods("0000ae015241","140","50","90","6","nail");
goods[955] =new setGoods("0000ae015242","150","50","90","6","nail");
goods[956] =new setGoods("0000ae015243","70","60","90","6","nail");
goods[957] =new setGoods("0000ae015244","80","60","90","6","nail");
goods[958] =new setGoods("0000ae015245","90","60","90","6","nail");
goods[959] =new setGoods("0000ae015246","100","60","90","6","nail");
goods[960] =new setGoods("0000ae015247","110","60","90","6","nail");
goods[961] =new setGoods("0000ae015248","120","60","90","6","nail");
goods[962] =new setGoods("0000ae015249","130","60","90","6","nail");
goods[963] =new setGoods("0000ae015250","140","60","90","6","nail");
goods[964] =new setGoods("0000ae015251","150","60","90","6","nail");
goods[965] =new setGoods("0000ae015252","40","40","90","6","nail");
goods[966] =new setGoods("0000ae015253","50","50","90","6","nail");
goods[967] =new setGoods("0000ae015254","60","60","90","6","nail");
goods[968] =new setGoods("0000ae015255","60","40","90","6","black");
goods[969] =new setGoods("0000ae015256","70","40","90","6","black");
goods[970] =new setGoods("0000ae015257","80","40","90","6","black");
goods[971] =new setGoods("0000ae015258","90","40","90","6","black");
goods[972] =new setGoods("0000ae015259","100","40","90","6","black");
goods[973] =new setGoods("0000ae015260","110","40","90","6","black");
goods[974] =new setGoods("0000ae015261","120","40","90","6","black");
goods[975] =new setGoods("0000ae015262","130","40","90","6","black");
goods[976] =new setGoods("0000ae015263","140","40","90","6","black");
goods[977] =new setGoods("0000ae015264","150","40","90","6","black");
goods[978] =new setGoods("0000ae015265","60","50","90","6","black");
goods[979] =new setGoods("0000ae015266","70","50","90","6","black");
goods[980] =new setGoods("0000ae015267","80","50","90","6","black");
goods[981] =new setGoods("0000ae015268","90","50","90","6","black");
goods[982] =new setGoods("0000ae015269","100","50","90","6","black");
goods[983] =new setGoods("0000ae015270","110","50","90","6","black");
goods[984] =new setGoods("0000ae015271","120","50","90","6","black");
goods[985] =new setGoods("0000ae015272","130","50","90","6","black");
goods[986] =new setGoods("0000ae015273","140","50","90","6","black");
goods[987] =new setGoods("0000ae015274","150","50","90","6","black");
goods[988] =new setGoods("0000ae015275","70","60","90","6","black");
goods[989] =new setGoods("0000ae015276","80","60","90","6","black");
goods[990] =new setGoods("0000ae015277","90","60","90","6","black");
goods[991] =new setGoods("0000ae015278","100","60","90","6","black");
goods[992] =new setGoods("0000ae015279","110","60","90","6","black");
goods[993] =new setGoods("0000ae015280","120","60","90","6","black");
goods[994] =new setGoods("0000ae015281","130","60","90","6","black");
goods[995] =new setGoods("0000ae015282","140","60","90","6","black");
goods[996] =new setGoods("0000ae015283","150","60","90","6","black");
goods[997] =new setGoods("0000ae015284","40","40","90","6","black");
goods[998] =new setGoods("0000ae015285","50","50","90","6","black");
goods[999] =new setGoods("0000ae015286","60","60","90","6","black");
goods[1000] =new setGoods("0000ae015287","60","40","90","6","bp");
goods[1001] =new setGoods("0000ae015288","70","40","90","6","bp");
goods[1002] =new setGoods("0000ae015289","80","40","90","6","bp");
goods[1003] =new setGoods("0000ae015290","90","40","90","6","bp");
goods[1004] =new setGoods("0000ae015291","100","40","90","6","bp");
goods[1005] =new setGoods("0000ae015292","110","40","90","6","bp");
goods[1006] =new setGoods("0000ae015293","120","40","90","6","bp");
goods[1007] =new setGoods("0000ae015294","130","40","90","6","bp");
goods[1008] =new setGoods("0000ae015295","140","40","90","6","bp");
goods[1009] =new setGoods("0000ae015296","150","40","90","6","bp");
goods[1010] =new setGoods("0000ae015297","60","50","90","6","bp");
goods[1011] =new setGoods("0000ae015298","70","50","90","6","bp");
goods[1012] =new setGoods("0000ae015299","80","50","90","6","bp");
goods[1013] =new setGoods("0000ae015300","90","50","90","6","bp");
goods[1014] =new setGoods("0000ae015301","100","50","90","6","bp");
goods[1015] =new setGoods("0000ae015302","110","50","90","6","bp");
goods[1016] =new setGoods("0000ae015303","120","50","90","6","bp");
goods[1017] =new setGoods("0000ae015304","130","50","90","6","bp");
goods[1018] =new setGoods("0000ae015305","140","50","90","6","bp");
goods[1019] =new setGoods("0000ae015306","150","50","90","6","bp");
goods[1020] =new setGoods("0000ae015307","70","60","90","6","bp");
goods[1021] =new setGoods("0000ae015308","80","60","90","6","bp");
goods[1022] =new setGoods("0000ae015309","90","60","90","6","bp");
goods[1023] =new setGoods("0000ae015310","100","60","90","6","bp");
goods[1024] =new setGoods("0000ae015311","110","60","90","6","bp");
goods[1025] =new setGoods("0000ae015312","120","60","90","6","bp");
goods[1026] =new setGoods("0000ae015313","130","60","90","6","bp");
goods[1027] =new setGoods("0000ae015314","140","60","90","6","bp");
goods[1028] =new setGoods("0000ae015315","150","60","90","6","bp");
goods[1029] =new setGoods("0000ae015316","40","40","90","6","bp");
goods[1030] =new setGoods("0000ae015317","50","50","90","6","bp");
goods[1031] =new setGoods("0000ae015318","60","60","90","6","bp");
goods[1032] =new setGoods("0000ae015319","60","40","90","6","gs");
goods[1033] =new setGoods("0000ae015320","70","40","90","6","gs");
goods[1034] =new setGoods("0000ae015321","80","40","90","6","gs");
goods[1035] =new setGoods("0000ae015322","90","40","90","6","gs");
goods[1036] =new setGoods("0000ae015323","100","40","90","6","gs");
goods[1037] =new setGoods("0000ae015324","110","40","90","6","gs");
goods[1038] =new setGoods("0000ae015325","120","40","90","6","gs");
goods[1039] =new setGoods("0000ae015326","130","40","90","6","gs");
goods[1040] =new setGoods("0000ae015327","140","40","90","6","gs");
goods[1041] =new setGoods("0000ae015328","150","40","90","6","gs");
goods[1042] =new setGoods("0000ae015329","60","50","90","6","gs");
goods[1043] =new setGoods("0000ae015330","70","50","90","6","gs");
goods[1044] =new setGoods("0000ae015331","80","50","90","6","gs");
goods[1045] =new setGoods("0000ae015332","90","50","90","6","gs");
goods[1046] =new setGoods("0000ae015333","100","50","90","6","gs");
goods[1047] =new setGoods("0000ae015334","110","50","90","6","gs");
goods[1048] =new setGoods("0000ae015335","120","50","90","6","gs");
goods[1049] =new setGoods("0000ae015336","130","50","90","6","gs");
goods[1050] =new setGoods("0000ae015337","140","50","90","6","gs");
goods[1051] =new setGoods("0000ae015338","150","50","90","6","gs");
goods[1052] =new setGoods("0000ae015339","70","60","90","6","gs");
goods[1053] =new setGoods("0000ae015340","80","60","90","6","gs");
goods[1054] =new setGoods("0000ae015341","90","60","90","6","gs");
goods[1055] =new setGoods("0000ae015342","100","60","90","6","gs");
goods[1056] =new setGoods("0000ae015343","110","60","90","6","gs");
goods[1057] =new setGoods("0000ae015344","120","60","90","6","gs");
goods[1058] =new setGoods("0000ae015345","130","60","90","6","gs");
goods[1059] =new setGoods("0000ae015346","140","60","90","6","gs");
goods[1060] =new setGoods("0000ae015347","150","60","90","6","gs");
goods[1061] =new setGoods("0000ae015348","40","40","90","6","gs");
goods[1062] =new setGoods("0000ae015349","50","50","90","6","gs");
goods[1063] =new setGoods("0000ae015350","60","60","90","6","gs");
goods[1064] =new setGoods("0000ae015351","60","40","90","6","mb");
goods[1065] =new setGoods("0000ae015352","70","40","90","6","mb");
goods[1066] =new setGoods("0000ae015353","80","40","90","6","mb");
goods[1067] =new setGoods("0000ae015354","90","40","90","6","mb");
goods[1068] =new setGoods("0000ae015355","100","40","90","6","mb");
goods[1069] =new setGoods("0000ae015356","110","40","90","6","mb");
goods[1070] =new setGoods("0000ae015357","120","40","90","6","mb");
goods[1071] =new setGoods("0000ae015358","130","40","90","6","mb");
goods[1072] =new setGoods("0000ae015359","140","40","90","6","mb");
goods[1073] =new setGoods("0000ae015360","150","40","90","6","mb");
goods[1074] =new setGoods("0000ae015361","60","50","90","6","mb");
goods[1075] =new setGoods("0000ae015362","70","50","90","6","mb");
goods[1076] =new setGoods("0000ae015363","80","50","90","6","mb");
goods[1077] =new setGoods("0000ae015364","90","50","90","6","mb");
goods[1078] =new setGoods("0000ae015365","100","50","90","6","mb");
goods[1079] =new setGoods("0000ae015366","110","50","90","6","mb");
goods[1080] =new setGoods("0000ae015367","120","50","90","6","mb");
goods[1081] =new setGoods("0000ae015368","130","50","90","6","mb");
goods[1082] =new setGoods("0000ae015369","140","50","90","6","mb");
goods[1083] =new setGoods("0000ae015370","150","50","90","6","mb");
goods[1084] =new setGoods("0000ae015371","70","60","90","6","mb");
goods[1085] =new setGoods("0000ae015372","80","60","90","6","mb");
goods[1086] =new setGoods("0000ae015373","90","60","90","6","mb");
goods[1087] =new setGoods("0000ae015374","100","60","90","6","mb");
goods[1088] =new setGoods("0000ae015375","110","60","90","6","mb");
goods[1089] =new setGoods("0000ae015376","120","60","90","6","mb");
goods[1090] =new setGoods("0000ae015377","130","60","90","6","mb");
goods[1091] =new setGoods("0000ae015378","140","60","90","6","mb");
goods[1092] =new setGoods("0000ae015379","150","60","90","6","mb");
goods[1093] =new setGoods("0000ae015380","40","40","90","6","mb");
goods[1094] =new setGoods("0000ae015381","50","50","90","6","mb");
goods[1095] =new setGoods("0000ae015382","60","60","90","6","mb");
goods[1096] =new setGoods("0000ae015383","60","40","90","6","ww");
goods[1097] =new setGoods("0000ae015384","70","40","90","6","ww");
goods[1098] =new setGoods("0000ae015385","80","40","90","6","ww");
goods[1099] =new setGoods("0000ae015386","90","40","90","6","ww");
goods[1100] =new setGoods("0000ae015387","100","40","90","6","ww");
goods[1101] =new setGoods("0000ae015388","110","40","90","6","ww");
goods[1102] =new setGoods("0000ae015389","120","40","90","6","ww");
goods[1103] =new setGoods("0000ae015390","130","40","90","6","ww");
goods[1104] =new setGoods("0000ae015391","140","40","90","6","ww");
goods[1105] =new setGoods("0000ae015392","150","40","90","6","ww");
goods[1106] =new setGoods("0000ae015393","60","50","90","6","ww");
goods[1107] =new setGoods("0000ae015394","70","50","90","6","ww");
goods[1108] =new setGoods("0000ae015395","80","50","90","6","ww");
goods[1109] =new setGoods("0000ae015396","90","50","90","6","ww");
goods[1110] =new setGoods("0000ae015397","100","50","90","6","ww");
goods[1111] =new setGoods("0000ae015398","110","50","90","6","ww");
goods[1112] =new setGoods("0000ae015399","120","50","90","6","ww");
goods[1113] =new setGoods("0000ae015400","130","50","90","6","ww");
goods[1114] =new setGoods("0000ae015401","140","50","90","6","ww");
goods[1115] =new setGoods("0000ae015402","150","50","90","6","ww");
goods[1116] =new setGoods("0000ae015403","70","60","90","6","ww");
goods[1117] =new setGoods("0000ae015404","80","60","90","6","ww");
goods[1118] =new setGoods("0000ae015405","90","60","90","6","ww");
goods[1119] =new setGoods("0000ae015406","100","60","90","6","ww");
goods[1120] =new setGoods("0000ae015407","110","60","90","6","ww");
goods[1121] =new setGoods("0000ae015408","120","60","90","6","ww");
goods[1122] =new setGoods("0000ae015409","130","60","90","6","ww");
goods[1123] =new setGoods("0000ae015410","140","60","90","6","ww");
goods[1124] =new setGoods("0000ae015411","150","60","90","6","ww");
goods[1125] =new setGoods("0000ae015412","40","40","90","6","ww");
goods[1126] =new setGoods("0000ae015413","50","50","90","6","ww");
goods[1127] =new setGoods("0000ae015414","60","60","90","6","ww");
